import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { ApiVisa } from '../../shared/api-visa.model';

@Injectable({ providedIn: 'root' })

export class PurchaseOrderSupplierAccessImportFileService extends BaseApiTemplateService<any> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-order/import-file-hdr/login-entity-ep';
  download_sample_path: string;


  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-order/import-file-hdr/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-order/import-file-hdr/login-entity-ep';
    this.download_sample_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'internal-purchase-order/import-file-hdr';
    this.httpClient = http;
  }
}
